import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const MASCOT = "https://customer-assets-jt897jd0.emergentagent.net/job_smoke-beach-drop/artifacts/g2ejgl6q_maskotka-obrys.webp";

export const FloatingBuddy = () => {
  const [hyped, setHyped] = useState(false);

  useEffect(() => {
    const target = document.getElementById("drop");
    if (!target) return;
    const obs = new IntersectionObserver(([entry]) => setHyped(entry.isIntersecting), { threshold: 0.15 });
    obs.observe(target);
    return () => obs.disconnect();
  }, []);

  return (
    <motion.a
      href="#drop"
      data-testid="floating-buddy"
      className="fixed bottom-4 right-4 z-[95] block w-24 cursor-pointer sm:bottom-6 sm:right-6 sm:w-36"
      initial={{ opacity: 0, y: 60, rotate: 8 }}
      animate={{
        opacity: 1,
        y: hyped ? -26 : 0,
        rotate: hyped ? -3 : 0,
        scale: hyped ? 1.12 : 1,
      }}
      transition={{ delay: 0.2, duration: 0.6, ease: [0.34, 1.56, 0.64, 1] }}
      whileHover={{ scale: hyped ? 1.2 : 1.08, rotate: -3 }}
      title="$IGN UP! buddy"
    >
      <motion.span
        className="smoke-puff absolute -top-8 left-2 rounded-full bg-[#f4f1ea]/40 blur-md"
        animate={{ height: hyped ? 56 : 40, width: hyped ? 56 : 40, opacity: hyped ? 0.9 : 0.6 }}
        transition={{ duration: 0.5 }}
      />
      {hyped && (
        <motion.span
          className="smoke-puff absolute -top-12 right-4 h-12 w-12 rounded-full bg-[#e5b83b]/50 blur-md"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          style={{ animationDelay: "0.9s" }}
        />
      )}
      <motion.img
        src={MASCOT}
        alt="$IGN UP! mascot buddy"
        className="w-full"
        style={{ filter: "drop-shadow(4px 4px 0 rgba(10,10,10,0.9))" }}
        animate={{ y: [0, hyped ? -14 : -8, 0], rotate: [0, 1.5, 0] }}
        transition={{ duration: hyped ? 1.8 : 3.4, repeat: Infinity, ease: "easeInOut" }}
      />
    </motion.a>
  );
};
